import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './open/login/login.component';
import { AleadyLoggedInGuard } from './services/guard/already-logged-in-guard/already-logged-in.guard';
import { authGuard } from './services/guard/auth-guard/auth-guard.guard';
import { hasRoleGuard, RoutePermissionRestriction } from './services/guard/has-role-guard/has-role.guard';
import { Privileges } from './services/enums/privileges.enum';
import { CreatePasswordComponent } from './core/auth/create-password/create-password.component';
import { TempLoggedInGuard } from './services/guard/temp-logged-in-guard/temp-logged-in-guard';
import { PaymentSuccessComponent } from "./open/payment/payment-success/payment-success.component";
import { PaymentInitializeComponent } from "./open/payment/payment-initialize/payment-initialize.component";
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { UnauthorizedAccessComponent } from './shared/components/unauthorized-access/unauthorized-access.component';
import { VerificationLandingComponent } from './open/verification/verification-landing/verification-landing.component';
import { VerificationDetailsComponent } from './open/verification/verification-details/verification-details.component';
import { ForgotPasswordComponent } from './open/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './open/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    pathMatch: 'full',
    canActivate: [AleadyLoggedInGuard]
  },

  {
    path: 'create-password',
    component: CreatePasswordComponent,
    pathMatch: 'full',
    canActivate: [TempLoggedInGuard]
  },

  {
    path: 'forget-password/:token',
    component: ResetPasswordComponent,
    pathMatch: 'full',
    canActivate: []
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [authGuard, hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ["MANAGE_SUB_AGENT", "MANAGE_SUPER_AGENT", "GENERAL_PERMISSION", 'LGA_HEAD', 'ADMIN'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./non-admin/non-admin.module').then((m) => m.NonAdminModule),
    canActivate: [authGuard],
    data: {
      permissions: [
        {
          permissions: [Privileges.NON_ADMIN],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./admin/pages/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [authGuard],
    data: {
      permissions: [
        {
          permissions: [],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'payment/return-back/:payRef',
    component: PaymentSuccessComponent,
    pathMatch: 'full',
  },
  {
    path: 'payment',
    component: PaymentInitializeComponent,
    pathMatch: 'full',
  },
  {
    path: 'verification',
    component: VerificationLandingComponent
  },
  {
    path: 'verification-view',
    component: VerificationDetailsComponent
  },
  {
    path: "404",
    component: NotFoundComponent,
    data: {
      isExtranet: true,
      hideLayout: true,
    },
  },

  {
    path: "401",
    component: UnauthorizedAccessComponent,
    data: {
      isExtranet: true,
      hideLayout: true,
    },
  },
  {
    path: "**",
    redirectTo: '404'
  },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
